const REMOTE_STATUS_ACTION = {
  IS_REMOTE_SUBSCRIPTION: 'IS_REMOTE_SUBSCRIPTION',
  REMOTE_SUBSCRIPTION_SUCCESS: 'REMOTE_SUBSCRIPTION_SUCCESS',
  REMOTE_SUBSCRIPTION_ERROR: 'REMOTE_SUBSCRIPTION_ERROR',
};

export default REMOTE_STATUS_ACTION;
